import { TopBarService } from 'libs/top-bar/src/lib/top-bar.service';
import { Injectable } from "@angular/core";
import { Subscription } from 'rxjs';
import { isEmpty } from '@ubi-cell/core-utils';
import {preferencesConstant} from "../../../../../apps/ubivu-panel/src/app/constants";
import {NodeService} from "../../../../../apps/ubivu-panel/src/app/serveices";
import {CommonTopBar} from "../../../../top-bar/src/lib/Helper/common-top-bar";

@Injectable({
    providedIn: 'root'
  })

  export class MapPlacePredictionsService {

    predictions: any[] = [];
    placesService: any;
    locationConverterService: any;
    placeId: string = ''; // Replace with the actual Place ID
    location: any; // This will store the location data;
    numberOfLocation: number = 3; // this number used for how many location we need to display while search location
    _map: any;
    latLngBounds: any;
    locationSearchFilterAppliedSub$: Subscription;
    MAP_ZOOM_LEVEL_THRESHOLD: number = 10;


    constructor(private _topBarConf: TopBarService,private _nodeService: NodeService,private _commonTobBar: CommonTopBar,) {
    }

    //Initialize Auto Complete Place Service
    initializePlacesServiceForSearchResult() {
      if (typeof google !== 'undefined') {
        this.placesService = new google.maps.places.AutocompleteService();
      }
    }

    //Initialize PlaceService which is use for getting location from placeId
    initializePlaceServiceForLocation(){
      if (typeof google !== 'undefined') {
        this.locationConverterService = new google.maps.places.PlacesService(document.createElement('div'));
      }
    }

    // Function for get place predictions array based on search keyword
    async onPlaceInputChange(searchResult: string) {
        if (!searchResult) {
          this.predictions = [];
          return this.predictions;
        }

        await this.getPredictions(searchResult).then(predictions => {
          this.predictions = predictions;
        })
        return this.predictions.slice(0,this.numberOfLocation) || [];
    }

    getPredictions(searchResult): Promise<any>{
      return new Promise((resolve, reject) => {
        this.placesService.getQueryPredictions({ input: searchResult }, (predictions: any, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            resolve(predictions);
          } else {
            resolve([]);
          }
        });
      })
     
    }

    // Async Function for get Location object from Place Id
    async getLocationByPlaceId(placeId: string) {
      let selectedLocationDetails = {};
      if (!placeId) {
        return;
      }
      const request = {
        placeId: placeId
      };

      await this.getPlaceDetails(placeId).then(locationData => {
        selectedLocationDetails['location'] = locationData.geometry.location;
        selectedLocationDetails['viewport'] = locationData.geometry.viewport;
        return selectedLocationDetails;
      });

      return selectedLocationDetails;
    }

    getPlaceDetails(placeId: string): Promise<any> {
      return new Promise((resolve, reject) => {
        this.locationConverterService.getDetails({ placeId: placeId }, (place, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            resolve(place);
          } else {
          }
        });
      });
    }

    //Re-Direct Map to Given Location
    redirectMapToSearchLocation(location){
      location = JSON.parse(location);
      const latLngBounds = new google.maps.LatLngBounds();
      latLngBounds.extend(new google.maps.LatLng(+location.lat, +location.lng));
      this.getMap().setCenter(latLngBounds.getCenter());
      this.getMap().fitBounds(location.viewport);
    }

    // Get Map Object
    getMap(): any {
      return this._map;
    }

    // Set Map object
    setMap(value: any) {
      this._map = value;
    }

  }
